import axios from "../../config/interceptor";

export const getPatients = async ({ businesId }) => {
  try {
    let link =
      `/lambda/get-users-by-business?business_id=${businesId}`;

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const checkRmNumber = async ({ businessId, rmNumber }) => {
  if (!businessId) {
    // Fail-closed: prevent unscoped lookup that could leak across clinics
    // or hit a 404 noise endpoint. Callers treat the throw as a generic
    // error and block submission.
    throw new Error("checkRmNumber: businessId is required");
  }
  try {
    // Use proxy-relative path so axios baseURL (REACT_APP_BASE_API_URL =
    // /api/legacy) routes this through the Next.js proxy, which calls the
    // ehealth.api2_check_patient_rm RPC. Hitting the raw Lambda directly
    // returns 500 (decommissioned in prod-next migration).
    let link =
      `/lambda/v1/users/patient/check-rm/${businessId}?rmNumber=${encodeURIComponent(
        rmNumber
      )}`;
    const response = await axios.get(link);
    return response;
  } catch (error) {
    throw error;
  }
};
